import React, { useReducer, useEffect, useMemo } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import './App.css';
import {
  GlobalStateCS,
  useGlobalStateSelector,
  words,
  getInitialIssuanceState,
  stateKeysToSetAddress,
  stateKeysToSetUserName,
} from './globalState';
import coininfo from 'coininfo';
import {
   SelectSecretPopup,
   SelectSessionPopup,
   ViewSessionPopup,
   SelectSubAddressPopup,
   MnemonicInputPopup,
   WifInputPopup,
   SelectAddressFromKeypoolPopup,
   SelectAddressFromKeypoolButton,
   SelectSessionButton,
   DisplayWifPopup,
} from './KeysAndSigningUI';
import { walletsAvailable } from './keysAndSigning';
import { TokenFilterSection, TokenFilterPopup } from './TokenFilter';
import { LoginPopup, RegistrationAndAgreementListPopup } from './LoginUI';
import { Setting, NfcCallback, handleClickSetting } from './Setting';
import {
  UserRegistrationPopup,
  ReadMnemonicForRegistrationPopup,
  ReadWifForRegistrationPopup,
} from './UserRegistration';
import {
  GeneralList,
  GeneralItems,
  ConfirmationPopup,
  ForDevelopment,
  NotificationFadingOut,
  RollingPearl,
  DisplayQrPopup,
  QrCodeScannerPopup,
  QrCodeReaderPopup,
} from './UtilComponents';
import {
  BalanceMona,
  BalanceXmp,
  BalanceMonaparty,
  CommitMonaTransactionConfirmationPopup,
  ItemDetail,
  ItemDetailMore,
  MonadomInfo,
  CreatorInformation,
  ActionHistory,
  Issuance,
  SendMonaPopup,
  SendXmpPopup,
  SendTokenPopup,
  EditAssetInfoPopup,
  CartMonaPopup,
  CartMonapartyPopup,
  FirstTransactionRitualPopup,
} from './WalletCoreComponents';
import {
   ConfirmMnemonicPopup,
} from './KeyBox';
import {
  handleClickReload,
} from './walletCore';
import {
   getRegisteredCard,
} from './blockchain';
import {
  devLog,
  hasCamera,
  decimalAdjust,
  syncHttpRequest2,
} from './utils';
import logoMonashell from './image/monashell_logo_logo.png';
import iconMenu from './image/menu_24dp_FILL0_wght400_GRAD0_opsz24.svg';
import sctHtml from './sct.static.html';

// let GlobalState;
let wallet;


// APP
function App() {
  const urlParams = (new URL(document.location)).searchParams;

  /* eslint-disable no-unused-vars */
  // 検索期間のデフォルト値
  const now = new Date();
  let yearLastMonth;
  let monthLastMonth;
  let dayEndLastMonth;

  if (now.getMonth() === 0) {
    yearLastMonth = now.getFullYear() - 1;
    monthLastMonth = 12;
  }
  else {
    yearLastMonth = now.getFullYear();
    monthLastMonth = now.getMonth();
  }

  if (now.getMonth() === 4 || now.getMonth() === 6 || now.getMonth() === 9 || now.getMonth() === 11) {
    dayEndLastMonth = 30;
  }
  else if (now.getMonth() === 2) {
    if (now.getFullYear() % 4 === 0) {
      dayEndLastMonth = 29;
    }
    else {
      dayEndLastMonth = 28;
    }
  }
  else {
    dayEndLastMonth = 31;
  }
  /* eslint-enable no-unused-vars */


  const initialState = {
    networkMona: coininfo('MONA').toBitcoinJS(),
    language: urlParams.get('language') === null ? 'japanese' : urlParams.get('language'),
    marginOfSessionTime: 60000,
    device: {
      hasCamera: undefined,
    },
    config: {
      clientParameters: {
        versionOfTheTermsAndConditions: 'dummy',
        versionOfPrivacyPolicy: 'dummy',
      },
    },
    configKB: {
      clientParameters: {
      },
    },
    login: {
      addressMain: '',
      displayAddressSection: false,
    },
    configure: {
      addressMain: '',
      userName: '',
      // images: {
      //   main: null,
      // },
      // imagesNew: {
      //   main: null,
      //   mainUrl: null,
      // },
      readTheTermsAndConditions: false,
      readPrivacyPolicy: false,
      acceptedVersionOfTheTermsAndConditions: null,
      acceptedVersionOfPrivacyPolicy: null,
      // profileText: '',
      displayAddressSection: false,
      mnemonic: null,
      wif: '',
      status: null,
    },
    keyPairs: {},
    sendMona: {
      addressFrom: null,
      addressTo: null,
      amount: { face: '1', value: 1 },
    },
    sendXmp: {
      addressFrom: null,
      addressTo: null,
      amount: { face: '1', value: 1 },
    },
    sendToken: {
      addressFrom: null,
      addressTo: null,
      asset: null,
      amount: { face: '1', value: 1 },
    },
    cartMonaparty: {
    },
    cartMona: {
    },
    actionHistory: [],
    getHistoryInBlockChain: {
      address: null,
      pageSize: { 'face': '1000', 'value': 1000 },
      maxPages: { 'face': '1000', 'value': 1000 },
      transactions: [],
    },
    tokenFilter: {
      conditions: [
        {
          assetCommon: [],
          addressOwners: [],
          lockStatus: [],
          monacardName: [],
          monacardIssuerNames: [],
          monacardDescription: [],
          monacardTags: [],
          monadom: [],
        },
      ],
      addressOwner: null,
      lockStatus: null,
      monacardName: null,
      monacardIssuerName: null,
      monacardDescription: null,
      monacardTag: null,
      monadom: null,
      conditionIndex: 0,
    },
    active: {
      addressMain: undefined,
      parent: null,
    },
    subAddresses: {},
    balance: {
      mona: {},
      monaparty: {}
    },
    user: {},
    usersMonacotto: {},
    session: {},
    assetInfo: {},
    addressTxids: {},
    monacard: {},
    registeredCard: {},
    searchDateRange: {
      from: {
        epoch: undefined, // new Date(yearLastMonth, monthLastMonth - 1, 1, 0, 0, 0, 0).getTime(),
        year: undefined, // yearLastMonth,
        month: undefined, // monthLastMonth,
        day: undefined, // 1, // now.getDate,
        hours: 0, // now.getHours,
        minutes: 0, // now.getMinutes,
        seconds: 0, // now.getSeconds,
        milliseconds: 0, // now.getMilliseconds,
      },
      to: {
        epoch: undefined, // new Date(yearLastMonth, monthLastMonth - 1, dayEndLastMonth, 23, 59, 59, 999).getTime(),
        year: undefined, // yearLastMonth,
        month: undefined, // monthLastMonth,
        day: undefined, // dayEndLastMonth,
        hours: 23,
        minutes: 59,
        seconds: 59,
        milliseconds: 999,
      },
    },
    notification: {
      body: [ '' ],
      index: 0,
      fixed: false,
      inAnimation: false,
    },
    popup: [
      { type: null, body: null },
      { type: null, body: null },
      { type: null, body: null },
      { type: null, body: null },
    ],
    accessing: false,
    pointSum: {},
    registeredItemAll: {},
    addressCheck: 'strict',
    creatorInformation: {
      creater: '',
      createrText: '',
      monacottoAddressMain: '',
      createrLink: [
        {
          title: '',
          url: '',
        },
        {
          title: '',
          url: '',
        },
        {
          title: '',
          url: '',
        },
      ],
    },
    animation: {
      youWinMona: 'visible',
    },
    displaySecret: {
      mnemonic: '',
      // mnemonicHidden: '',
      wif: '',
      address: '',
      swapMnemonics: '',
      mnemonicToWif: '',
      wifFromMnemonic: '',
    },
    walletType: urlParams.get('wallettype') === null ? walletsAvailable({ hasCamera: undefined })[0] : urlParams.get('wallettype'),
    qrCodeScanner: {
      qrCode: undefined,
    },
    displayName: 'asset_longname',
    // test: test,
    issuance: getInitialIssuanceState(),
    editAssetInfo: {
      editMode: 'editMonacard',
      imagesNew: {
        monacard: null,
        monacardUrl: null,
      },
      assetIssuer: '',
      assetCommon: '',
      supply: null,
      amount: { face: '', value: '' },
      monacardName: '',
      monacardIssuerName: '',
      monacardDescription: '',
      monacardTag: '',
      cid: '',
      lock: null,
      divisible: null,
      listed: null,
      vendable: null,
      reassignable: null,
    },
    ownedAssets: {},
    passkey: {
      busy: false,
    },
    unregisteredAddress: {
      address: '',
    },
    savePasswordEncryptedMnemonic: {
      password: '',
      passwordExpressionType: 'kana',
      wordCount: '5',
    },
    loadPasswordEncryptedMnemonic: {
      password: '',
    },
  }

  const [state, dispatch] = useReducer(reducer, initialState);
  const navigate = useNavigate();
  // GlobalState = React.createContext([state, dispatch, navigate, cookies, setCookie, removeCookie]);

  useEffect( () => {
    const func = async () => {
      // // AppConnect対応
      // window.monapaletteConnect.getAddress().then(() => window.mpurse = window.monapaletteConnect).catch(() => {});

      // カメラある？

      hasCamera().then( (hasCamera) => {
        devLog('has camera; ', hasCamera);

        dispatch({ type: 'setStateMultiLayers', keys: ['device', 'hasCamera'], value: hasCamera });

        if (hasCamera && (state.walletType === undefined || state.walletType === null)) {
          dispatch({ type: 'setState', key: 'walletType', value: 'qr' });
        }
      });

      // 各種設定値取得
      // devLog('mainaddress', urlParams.get('mainaddress'));

      // -- cookie情報取得
      // if (cookies.addressCheck !== undefined) {
      //   dispatch({ type: 'setState', key: 'addressCheck', value: cookies.addressCheck });
      // }

      dispatch({ type: 'setState', key: 'accessing', value: true });

      const configKeys = ['clientParameters'];
      getConfig(dispatch, 'monashell', configKeys , 'config');

      const configKeysKB = ['clientParameters'];
      getConfig(dispatch, 'keybox', configKeysKB , 'configKB');

      // 初期通知表示
      // dispatch({ type: 'setStateMultiLayers', keys: ['notification', 'body', 0], value: config.body.initialNotification.value });

      // // -- 登録カード情報取得

      getRegisteredCard(state, dispatch);

      dispatch({ type: 'setState', key: 'accessing', value: false });

      devLog('domain', document.domain);
      console.log('domain', document.domain);
    };

    func();
  }, []);

  let bottomUp;

  if (wallet === 'MonaPallet') {
    bottomUp =
    <div className="appConnectBottomUp">
    </div>;
  }

  const value = useMemo(
    () => ({ state, dispatch, navigate }),
    [state, dispatch, navigate]
  );

  return (
    <GlobalStateCS.Provider value={value}>
      <div className="App">
        <Routes>
          {/* <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/' : '/'} element={<LP />} /> */}
          {/* <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/index.html' : '/index.html'} element={<LP />} /> */}
          <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/' : '/'} element={<Top />} />
          <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/index.html' : '/index.html'} element={<Top />} />
          <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/top' : '/top'} element={<Top />} />
          <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/setting' : '/setting'} element={<Setting />} />
          <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/nfc-callback' : '/nfc-callback'} element={<NfcCallback />} />
          <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/history' : '/history'} element={<ActionHistory />} />
          <Route exact path={ process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/issuance' : '/issuance'} element={<Issuance />} />
        </Routes>
        { bottomUp }
        <NotificationFadingOut />
        <RollingPearl />
        {/* popup (global; available on all routes) */}
        <Popup layer={0}/>
        <Popup layer={1}/>
        <Popup layer={2}/>
        <Popup layer={3}/>
        <Popup layer={4}/>
        <Popup layer={5}/>
        <Popup layer={6}/>
      </div>
    </GlobalStateCS.Provider>
  );
}

// TOP
function Top() {
  return (
    <div className=''>
      {/* PC */}
      <div className="visibleMiddleOrMore mainKOM">
        <div className="flexColumn alignItemsCenter relative">
          <Header />
          <BalanceMonaparty />
          {/* development */}
          { process.env.REACT_APP_ENVIRONMENT === 'dev' ? <ForDevelopment /> : null }
        </div>
        {/* footer */}
        <Footer />
      </div>
      {/* SP */}
      <div className="flexColumn visibleSmallOrLess mainKOM ">
        <div className="flexColumn alignItemsCenter relative widthMax">
          <Header />
          <BalanceMonaparty />
        </div>
        {/* menu button */}
        <MenuButton />
        {/* footer */}
        <Footer />
      </div>
    </div>
  );
}

// HEADER
function Header() {
  return (
    <div className='widthMax'>
      {/* PC */}
      <div className='visibleMiddleOrMore flexRow justifyContentSpaceBetween alignItemsFlexStart widthMax'>
        <div className='flexRow ' >
          <img className='width14' src={logoMonashell} alt='' />
          <div>
            { process.env.REACT_APP_ENVIRONMENT === 'dev' ? 'dev' : null }
          </div>
        </div>
        <div className='flexRow'>
          <div className='marginSide1' >
            <BalanceMona />
          </div>
          <div className='marginSide1' >
            <BalanceXmp />
          </div>
        </div>
        <div className='flexColumn justifyContentFlexStart alignItemsFlexEnd '>
          <MenuSection />
          <div className='flexRow'>
            <SelectSessionButton popupLayer={null} loginEnabled={true} setConfigure={true} />
            <SelectAddressFromKeypoolButton
              popupLayer={null}
              stateKeysToSetAddress={stateKeysToSetAddress}
              stateKeysToSetUserName={stateKeysToSetUserName}
              loginEnabled={true}
              setConfigure={true}
              subAddressEnabled={true}
            />
          </div>
        </div>
      </div>
      {/* SP */}
      <div className="visibleSmallOrLess flexColumn alignItemsCenter ">
        <div>
          { process.env.REACT_APP_ENVIRONMENT === 'dev' ? 'dev' : null }
        </div>
        <img className='width14' src={logoMonashell} alt='' />
        <div className='marginSide1' >
          <BalanceMona />
        </div>
        <div className='marginSide1' >
          <BalanceXmp />
        </div>
        <MenuSection />
        <div className='flexRow'>
          <SelectSessionButton popupLayer={null} loginEnabled={true} setConfigure={true} />
          <SelectAddressFromKeypoolButton
            popupLayer={null}
            stateKeysToSetAddress={stateKeysToSetAddress}
            stateKeysToSetUserName={stateKeysToSetUserName}
            loginEnabled={true}
            setConfigure={true}
            subAddressEnabled={true}
          />
        </div>
      </div>
    </div>
  );
}

// FOOTER
function Footer() {
  const { state, dispatch } = useGlobalStateSelector(({ state, dispatch }) => ({ state, dispatch }));

  return (
    <div className='footer'>
      <button className={'borderNone backgroundColorTransparent marginSide1 focusEffect01 cursor'} tabindex='0'
        onClick={ () => {
          window.open('https://' + process.env.REACT_APP_ABOUT_US);
        }}
      >
        {words.aboutUs[state.language]}
      </button>
      <button className={'borderNone backgroundColorTransparent marginSide1 focusEffect01 cursor'} tabindex='0'
        onClick={ () => {
          const popup = { type: 'generalItems', body: <div dangerouslySetInnerHTML={ { __html: sctHtml } } /> };
          dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: popup });
        }}
      >
        {words.notationBasedOnTheActOnSpecifiedCommercialTransactions[state.language]}
      </button>
      {/*
        <button className={'borderNone backgroundColorTransparent marginSide1 focusEffect01 cursor'} tabindex='0'
          onClick={ () => {
            window.open('https://spotlight.soy/detail?article_id=ckkgeevvg');
          }}
        >
          {words.guideline[state.language]}
        </button>
      */}
    </div>
  );
}

// MENU BUTTON
function MenuButton() {
  const { dispatch } = useGlobalStateSelector(({ dispatch }) => ({ dispatch }));

  return (
    <button className='button1 buttonTopRight'
      onClick={ () => {
        const popup = { type: 'menuPopup' };
        dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: popup });
      }}
    >
      <img className='size2x2' src={iconMenu} alt='' />
    </button>
  );
}

// MENU SECTION
function MenuSection(props) {
  const { state, dispatch, navigate } = useGlobalStateSelector(({ state, dispatch, navigate }) => ({ state, dispatch, navigate }));
  const popupLayer = props.popupLayer;
  const popupLayerNext = popupLayer !== undefined ? popupLayer + 1 : 0;

  let cartMonaBackground = '';

  if (Object.keys(state.cartMona).length > 0) {
    cartMonaBackground = ' backgroundColorPinkPale';
  }

  let cartMonapartyBackground = '';

  if (Object.keys(state.cartMonaparty).length > 0) {
    cartMonapartyBackground = ' backgroundColorPinkPale';
  }


  return (
    <div className='flexRow justifyContentCenter' >
      <button className={'button2 flexColumn alignItemsCenter' + cartMonaBackground}
        onClick={ () => {
          const popup = { type: 'cartMonaPopup' };
          dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
        }}
      >
        <div className='' >
          { words.cart[state.language] }
        </div>
        <div className='' >
          { words.monaInBrackets[state.language] }
        </div>
      </button>
      <button className={'button2 flexColumn alignItemsCenter' + cartMonapartyBackground}
        onClick={ () => {
          const popup = { type: 'cartMonapartyPopup' };
          dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
        }}
      >
        <div className='' >
          { words.cart[state.language] }
        </div>
        <div className='' >
          { words.tokenInBrackets[state.language] }
        </div>
      </button>
      <TokenFilterSection popupLayerNext={popupLayerNext} />
      <button className='button2'
        onClick={ () => {
          navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/issuance' : '/issuance');

          if (popupLayer !== undefined) {
            dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer], value: { type: null, body: null } }); 
          }
        }}
      >
        { words.issueMonacard[state.language] }
      </button>
      <button className='button2'
        onClick={ () => {
          navigate(process.env.REACT_APP_ENVIRONMENT === 'dev' ? '/build/history' : '/history');
          dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer], value: { type: null, body: null } }); 
        }}
      >
        { words.history[state.language] }
      </button>
      <button className='button2'
        onClick={ () => {
          handleClickSetting(state, dispatch, navigate);
          dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer], value: { type: null, body: null } }); 
        }}
      >
        { words.setting[state.language] }
      </button>
      <button className='button2'
        onClick={ () => {
          handleClickReload(state, dispatch);
        }}
      >
        { words.reload[state.language] }
      </button>
      <button className='button2'
        onClick={ () => {
          if (state.walletType === undefined || state.walletType === null) {
            const walletType = walletsAvailable({ hasCamera: state?.device?.hasCamera })[0];
            dispatch({ type: 'setState', key: 'walletType', value: walletType });
          }

          const popup = { type: 'userRegistrationPopup', mode: 'webauthnOnly' };
          dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
        }}
      >
        { words.userRegistration[state.language] }
      </button>
      <button className='button2'
        onClick={ () => {
          if (state.walletType === undefined || state.walletType === null) {
            const walletType = walletsAvailable({ hasCamera: state?.device?.hasCamera })[0];
            dispatch({ type: 'setState', key: 'walletType', value: walletType });
          }

          const popup = { type: 'loginPopup' };
          dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
        }}
      >
        { words.login[state.language] }
      </button>
    </div>
  );
}

// MENU POPUP
function MenuPopup(props) {
  const popupLayer = props.popupLayer;

  return <MenuSection popupLayer={popupLayer} />;
}


// POPUP
function Popup(props) {
  const { state, dispatch } = useGlobalStateSelector(({ state, dispatch }) => ({ state, dispatch }));

  const popup = state.popup[props.layer];

  const popupComponent = {
    generalList: <GeneralList popupLayer={props.layer} />,
    generalItems: <GeneralItems popupLayer={props.layer} />,
    confirmationPopup: <ConfirmationPopup popupLayer={props.layer} />,
    commitMonaTransactionConfirmationPopup: <CommitMonaTransactionConfirmationPopup popupLayer={props.layer} />,
    qrCodeScannerPopup: <QrCodeScannerPopup popupLayer={props.layer} />,
    itemDetail: <ItemDetail popupLayer={props.layer} />,
    itemDetailMore: <ItemDetailMore popupLayer={props.layer} />,
    monadomInfo: <MonadomInfo popupLayer={props.layer} />,
    userRegistrationPopup: <UserRegistrationPopup popupLayer={props.layer} />,
    loginPopup: <LoginPopup popupLayer={props.layer} />,
    menuPopup: <MenuPopup popupLayer={props.layer} />,
    selectSessionPopup: <SelectSessionPopup popupLayer={props.layer} />,
    viewSessionPopup: <ViewSessionPopup popupLayer={props.layer} />,
    sendMonaPopoup: <SendMonaPopup popupLayer={props.layer} />,
    sendXmpPopoup: <SendXmpPopup popupLayer={props.layer} />,
    sendTokenPopup: <SendTokenPopup popupLayer={props.layer} />,
    editAssetInfoPopup: <EditAssetInfoPopup popupLayer={props.layer} />,
    tokenFilterPopup: <TokenFilterPopup popupLayer={props.layer} />,
    cartMonaPopup: <CartMonaPopup popupLayer={props.layer} />,
    cartMonapartyPopup: <CartMonapartyPopup popupLayer={props.layer} />,
    displayQrPopup: <DisplayQrPopup popupLayer={props.layer} />,
    displayWifPopup: <DisplayWifPopup popupLayer={props.layer} />,
    creatorInformation: <CreatorInformation popupLayer={props.layer} />,
    firstTransactionRitualPopup: <FirstTransactionRitualPopup popupLayer={props.layer} />,
    confirmMnemonicPopup: <ConfirmMnemonicPopup popupLayer={props.layer} />,
    registrationAndAgreementListPopup: <RegistrationAndAgreementListPopup popupLayer={props.layer} />,
    selectSecretPopup: <SelectSecretPopup popupLayer={props.layer} />,
    selectSubAddressPopup: <SelectSubAddressPopup popupLayer={props.layer} />,
    readMnemonicForRegistrationPopup: <ReadMnemonicForRegistrationPopup popupLayer={props.layer} />,
    readWifForRegistrationPopup: <ReadWifForRegistrationPopup popupLayer={props.layer} />,
    qrCodeReaderPopup: <QrCodeReaderPopup popupLayer={props.layer} />,
    mnemonicInputPopup: <MnemonicInputPopup popupLayer={props.layer} />,
    wifInputPopup: <WifInputPopup popupLayer={props.layer} />,
    selectAddressFromKeypoolPopup: <SelectAddressFromKeypoolPopup popupLayer={props.layer} />,
  };

  if (state.popup[props.layer]?.type === undefined || state.popup[props.layer].type === null) {
    return (
      <div className='invisible' />
    );
  }
  else {
    return (
      <div>
        {/* PC */}
        <div className="visibleMiddleOrMore">
          <div className={'popupBackgroundMultiLayer' + (popup.extendedClassesBackGround !== undefined ? ' ' + popup.extendedClassesBackGround : '')} style={{ '--popupLayer': props.layer }}>
            <button className='closePopupMultiLayer' style={{ '--popupLayer': props.layer }}
              onClick={ () => dispatch({ type: 'setStateMultiLayers', keys: ['popup', props.layer], value: { type: null, body: null } }) }
            />
            <div className='popupMultiLayer' style={{ '--popupLayer': props.layer }}>
              <button className='topRightClose font2 focusEffect01' tabindex='0'
                onClick={ () => dispatch({ type: 'setStateMultiLayers', keys: ['popup', props.layer], value: { type: null, body: null } }) } 
              >
                ×
              </button>
              {popupComponent[state.popup[props.layer].type]}
            </div>
          </div>
        </div>
        {/* SP */}
        <div className="visibleSmallOrLess">
          <div className='popupBackgroundMultiLayer' style={{ '--popupLayer': props.layer }}>
            <button className='closePopupMultiLayer' style={{ '--popupLayer': props.layer }}
              onClick={ () => dispatch({ type: 'setStateMultiLayers', keys: ['popup', props.layer], value: { type: null, body: null } }) }
            />
            <div className='popupMultiLayerSmallScreen ' style={{ '--popupLayer': props.layer }}>
              <button className='topRightClose font2 focusEffect01' tabindex='0'
                onClick={ () => dispatch({ type: 'setStateMultiLayers', keys: ['popup', props.layer], value: { type: null, body: null } }) } 
              >
                ×
              </button>
              {popupComponent[state.popup[props.layer].type]}
            </div>
          </div>
        </div>
      </div>
    );
  }
  // else {
  //   return (
  //     <div className='' >
  //     </div>
  //   );
  // }
}

// ---------------------------



// // LOAD DECK
// async function loadDeck(state, dispatch, certification) {
//   let request = {};
//   let messages = {};
//   const now = Date.now();
// 
//   // state固定
//   const stateFixed = {
//   };
// 
//   const addressMainsValid = Object.keys(state.session).filter( addressMain => state.session[addressMain].expirationOfSession >= now + marginOfSessionTime )
//   let certifications = addressMainsValid.map( addressMain => { return { addressMain: addressMain, sessionId: state.session[addressMain].sessionId }; } )
// 
//   if (certification !== undefined && certification !== null && !addressMainsValid.includes(certification.addressMain)) {
//     certifications = certifications.concat([certification]);
//   }
// 
//   request.body = JSON.stringify({
//     body: {
//       certifications: certifications,
//     }
//   });
// 
//   request.url = 'https://' + process.env.REACT_APP_KOM_API_DOMAIN + '/load_deck';
//   request.method = 'POST';
// 
//   messages = {
//   };
// 
//   const response = await syncHttpRequest2(request, 'deckSet', undefined, undefined, messages, dispatch);
// 
//   if ( response.status === 'rejected' ) {
//     const deckSets = {};
// 
//     for (const addressMain of Object.keys(state.session)) {
//       deckSets[addressMain] = {
//         currentDeckNo: 1,
//         decks: [
//           null,
//           {
//             deckName: 'deck1',
//             cards: [
//             ],
//           },
//         ],
//       };
//     }
// 
//     dispatch({ type: 'setState', key: 'deckSet', value: deckSets });
// 
//     return {
//       status: 'rejected',
//       body: deckSets,
//     };
//   }
// 
//   return {
//     status: 'fulfilled',
//     body: response.body,
//   };
// }


async function getConfig(dispatch, project, keys, stateKey) {
  let request = {};
  let messages = {};

  request.body = JSON.stringify({
    body: {
      project: project,
      keys: keys,
    }
  });

  request.url = 'https://' + process.env.REACT_APP_MS_API_DOMAIN + '/get_client_parameter';
  request.method = 'POST';

  messages = {
  };

  const response = await syncHttpRequest2(request, stateKey, undefined, undefined, messages, dispatch);

  if ( response.status === 'fulfilled' ) {
    return {
      status: 'fulfilled',
      body: response,
    };
  }
  else {
    return {
      status: 'rejected',
    };
  }
}


// REDUCER
function reducer(state, action) {
  let newState = { ...state };
  // let numericCharacter;
  // let number;
  // let isChanged;
  // let items;
  // let item;
  // let newIndex;

  switch (action.type) {
    case 'setState': {
      newState[action.key] = action.value;
      return newState;
    }

    case 'setStateMultiLayers': {
      if (!Array.isArray(action.keys) || action.keys.length === 0) {
        return state;
      }

      const isIndexKey = (key) => {
        if (typeof key === 'number') return Number.isInteger(key) && key >= 0;
        if (typeof key === 'string') return /^[0-9]+$/.test(key);
        return false;
      };

      action.keys.reduce((acc, cur, idx) => {
        const isLast = idx === action.keys.length - 1;
        if (isLast) {
          acc[cur] = action.value;
          return acc[cur];
        }
        const currentValue = acc[cur];
        const nextKey = action.keys[idx + 1];
        let nextLayer;

        if (Array.isArray(currentValue)) {
          nextLayer = [...currentValue];
        }
        else if (currentValue && typeof currentValue === 'object') {
          nextLayer = { ...currentValue };
        }
        else if (isIndexKey(nextKey)) {
          nextLayer = [];
        }
        else {
          nextLayer = {};
        }

        acc[cur] = nextLayer;
        return nextLayer;
      }, newState);

      return newState;
    }

    // case 'setStateMultiLayers':
    //   action.keys.concat([action.value]).reduce( (acc, cur, idx, src) => {
    //     if (idx === src.length - 1) {
    //       return acc;
    //     }
    //     if (idx === src.length - 2) {
    //       return acc[cur] = src[idx + 1];
    //     }
    //     else {
    //       return acc[cur];
    //     }
    //   }, newState );
    //   return newState;

    case 'setStateNum': {
      const number = parseInt(action.value, 10);

      if (Number.isNaN(number)) {
        newState[action.key] = ''
      }
      else {
        newState[action.key] = number;
      }

      return newState;
    }

    case 'setStateMultiLayersNum': {
      let number = parseInt(action.value, 10);

      if (Number.isNaN(number)) {
        number = ''
      }

      action.keys.reduce( (acc, cur, idx, src) => {
        if (idx === src.length - 1) {
          return acc[cur] = number;
        }
        else {
          return acc[cur];
        }
      }, newState );

      return newState;
    }

    case 'setStateFloat': {
      const number = parseFloat(action.value);

      if (Number.isNaN(number)) {
        newState[action.key] = ''
      }
      else {
        newState[action.key] = number;
      }

      return newState;
    }

    case 'setStateMultiLayersFloat': {
      if (!Array.isArray(action.keys) || action.keys.length === 0) {
        return state;
      }

      const isIndexKey = (key) => {
        if (typeof key === 'number') return Number.isInteger(key) && key >= 0;
        if (typeof key === 'string') return /^[0-9]+$/.test(key);
        return false;
      };

      const faceSource = action.value === undefined || action.value === null ? '' : String(action.value);
      const numericCharacter = faceSource.replace(/[^\d.]/g, '');
      let number = parseFloat(numericCharacter);

      if (Number.isNaN(number)) {
        number = ''
      }
      else if (action.adjustType !== undefined) {
        number = decimalAdjust(action.adjustType, number, action.adjustExp);
      }

      action.keys.reduce((acc, cur, idx) => {
        const isLast = idx === action.keys.length - 1;

        if (isLast) {
          const currentLeaf = acc[cur];
          let nextLeaf;

          if (currentLeaf && typeof currentLeaf === 'object' && !Array.isArray(currentLeaf)) {
            nextLeaf = { ...currentLeaf };
          }
          else {
            nextLeaf = {};
          }

          nextLeaf.face = numericCharacter;
          nextLeaf.value = number;

          acc[cur] = nextLeaf;
          return acc[cur];
        }

        const currentValue = acc[cur];
        const nextKey = action.keys[idx + 1];
        let nextLayer;

        if (Array.isArray(currentValue)) {
          nextLayer = [...currentValue];
        }
        else if (currentValue && typeof currentValue === 'object') {
          nextLayer = { ...currentValue };
        }
        else if (isIndexKey(nextKey)) {
          nextLayer = [];
        }
        else {
          nextLayer = {};
        }

        acc[cur] = nextLayer;
        return nextLayer;
      }, newState);

      return newState;
    }

    // // setStateMultiLayersFloat
    // case 'setStateMultiLayersFloat':
    //   numericCharacter = action.value.replace(/[^\d.]/, '');
    //   number = parseFloat(numericCharacter);

    //   if (Number.isNaN(number)) {
    //     number = ''
    //   }
    //   else if (action.adjustType !== undefined) {
    //     number = decimalAdjust(action.adjustType, number, action.adjustExp);
    //   }

    //   action.keys.reduce( (acc, cur, idx, src) => {
    //     if (idx === src.length - 1) {
    //       acc[cur].face = numericCharacter;
    //       acc[cur].value = number;
    //       return acc[cur];
    //     }
    //     else {
    //       return acc[cur];
    //     }
    //   }, newState );

    //   return newState;

    case 'setStateMultiLayersMasked': {
      if (!Array.isArray(action.keys) || action.keys.length === 0) {
        return state;
      }

      const isIndexKey = (key) => {
        if (typeof key === 'number') return Number.isInteger(key) && key >= 0;
        if (typeof key === 'string') return /^[0-9]+$/.test(key);
        return false;
      };

      action.keys.reduce((acc, cur, idx) => {
        const isLast = idx === action.keys.length - 1;

        if (isLast) {
          const currentLeaf = acc[cur];
          let nextLeaf;

          if (currentLeaf && typeof currentLeaf === 'object' && !Array.isArray(currentLeaf)) {
            nextLeaf = { ...currentLeaf };
          }
          else {
            nextLeaf = {};
          }

          nextLeaf.face = '*'.repeat(action.value ? action.value.length : 0);
          nextLeaf.value = action.value;

          acc[cur] = nextLeaf;
          return acc[cur];
        }

        const currentValue = acc[cur];
        const nextKey = action.keys[idx + 1];
        let nextLayer;

        if (Array.isArray(currentValue)) {
          nextLayer = [...currentValue];
        }
        else if (currentValue && typeof currentValue === 'object') {
          nextLayer = { ...currentValue };
        }
        else if (isIndexKey(nextKey)) {
          nextLayer = [];
        }
        else {
          nextLayer = {};
        }

        acc[cur] = nextLayer;
        return nextLayer;
      }, newState);

      return newState;
    }

    // adjustFace
    case 'adjustFace': {
      action.keys.reduce( (acc, cur, idx, src) => {
        if (idx === src.length - 1) {
          acc[cur].face = acc[cur].value;
          return acc[cur];
        }
        else {
          return acc[cur];
        }
      }, newState );

      return newState;
    }

    // pushOut
    case 'pushOut': {
      const target = action.targetKeys.reduce( (acc, cur) => {
          return acc[cur];
      }, newState );

      action.keys.reduce( (acc, cur, idx, src) => {
        const pushedOut = target[cur];
        target[cur] = acc;
        return  pushedOut;
      }, action.value );

      return newState;
    }

    case 'setStateIfChange': {
      if (newState[action.key] !== action.value) {
        newState[action.key] = action.value;
        return newState;
      }
      else {
        return state;
     }
    }

    case 'setStateMultiLayersIfChange': {
      const isChanged = action.keys.concat([action.value]).reduce( (acc, cur, idx, src) => {
        if (idx === src.length - 1) {
          return acc;
        }
        if (idx === src.length - 2) {
          if (acc[cur] !== src[idx + 1]) {
            acc[cur] = src[idx + 1];
            return true;
          }
          else {
            return false;
          }
        }
        else {
          return acc[cur];
        }
      }, newState );

      if (isChanged) {
        return newState;
      }
      else {
        return state;
      }
    }

    // setNotification
    case 'setNotification': {
      newState[action.key].body.push(action.value);

      if (newState[action.key].body.length > state.config.clientParameters.notificationMaxLength) {
        newState[action.key].body.shift();
      }

      newState[action.key].index = newState[action.key].body.length -1;

      newState[action.key].inAnimation = true;

      return newState;
    }

    case 'stopNotificationAnimation': {
      newState[action.key].inAnimation = false;
      return newState;
    }

    // itemReplace
    case 'itemReplace': {
      const items = newState.items[newState.gallery.addressMain].itemPlacement[0].items;
      const item = items[action.index];

      let newIndex;
      if (action.direction === 'left') {
        newIndex = action.index - 1 >= 0 ? action.index -1 : items.length - 1;
      }
      else { // right
        newIndex = action.index + 1 <= items.length - 1 ? action.index + 1 : 0;
      }

      items.splice(action.index, 1);
      items.splice(newIndex, 0, item);

      return newState;
    }

    // default
    default: {
      return state;
    }
  }
}


export default App;

export {
  Popup,
};